import { useAppConfig } from '@msrceng/auth';
import rss from './rss.png';
import { ActionButton, registerIcons } from '@fluentui/react';

registerIcons({
  icons: {
    rss: (
      <span
        style={{
          maxHeight: '36px',
          minHeight: '1px',
        }}
      >
        <img
          src={rss}
          alt='RSS'
          style={{
            maxHeight: '36px',
            minHeight: '1px',
            width: '0.9em',
            height: '0.9em',
            verticalAlign: 'middle',
          }}
        />
      </span>
    ),
  },
});

/**
 * A button that links to the RSS feed for the security update guide.
 */
export const RssButton = () => {
  const itemProps = useRssButtonItemProps();

  return <ActionButton {...itemProps} />;
};

export const useRssButtonItemProps = () => {
  const { apiRoot } = useAppConfig();

  const rssLink = apiRoot + '/update-guide/rss';

  return {
    iconProps: {
      iconName: 'rss',
    },
    text: 'RSS',
    title: 'Security Update Guide RSS Feed',
    href: rssLink,
  };
};
